import type React from 'react';

import { Box, Icon, Text } from '@zillow/constellation-10';
import { IconChevronRightFilled } from '@zillow/constellation-icons';

export type ListCellProps = {
  addBorderBottom?: boolean;
  cta?: React.ReactNode;
  ctaIcon?: boolean;
  icon: React.ReactNode;
  onHeaderClick?: () => void;
  primaryText: string;
  secondaryText: string;
};

const ListCell = ({
  addBorderBottom = false,
  cta = null,
  ctaIcon = true,
  icon,
  onHeaderClick,
  primaryText,
  secondaryText,
}: ListCellProps) => {
  return (
    <Box
      data-testid="ListCell"
      css={{
        padding: '{spacing.400} 0',
        borderTop: '1px solid {colors.border.subtle}',
        borderBottom: addBorderBottom ? '1px solid {colors.border.subtle}' : 'none',
      }}
    >
      <Box
        css={{ display: 'flex', width: '100%', cursor: onHeaderClick ? 'pointer' : 'inherit' }}
        onClick={onHeaderClick}
      >
        <Box
          css={{
            width: '100%',
            display: 'grid',
            gridTemplateColumns: { base: '15% 75% 8%', md: '17% 71% 8%', lg: '15% 75% 8%' },
            gap: '0',
            alignItems: 'center',
            justifyItems: 'center',
          }}
        >
          <Box>{icon}</Box>
          <Box css={{ justifySelf: 'start' }}>
            <div>
              <Text asChild>
                <b>{primaryText}</b>
              </Text>
              <Text textStyle="body-sm" asChild css={{ color: '#596b82' }}>
                <p>{secondaryText}</p>
              </Text>
            </div>
          </Box>
          <Box>
            {ctaIcon && (
              <Icon size="md" css={{ color: 'icon.accent.brand.hero' }} render={<IconChevronRightFilled />} />
            )}
          </Box>
        </Box>
      </Box>

      <Box
        css={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: { base: '15% 85%' },
          gap: '0',
          alignItems: 'center',
          justifyItems: 'start',
        }}
      >
        <Box css={{ gridColumn: '2 / span 2' }}>{cta}</Box>
      </Box>
    </Box>
  );
};

export default ListCell;
